export default __webpack_public_path__ + "static/media/linkedin.ecea07a8.svg";